module.exports = __webpack_public_path__ + "media/images/stripe-a64538cce6fc45e90f773c56e7559c1d.png";